import React from 'react';
import { Row, Col, Select, DatePicker, Button, Radio, Table, Spin, Space , ConfigProvider} from 'antd';
import { RightOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import { APIService } from '../../../services/appraisement/api';
import { CalendarTimeService } from '../../../services/calendar/calendar.tool.service.js';
import { CodeOutlined, PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import 'moment/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
import VueTable from './VueTable.jsx';
import locale from 'antd/es/date-picker/locale/zh_CN';
import './Valuation.scss'
import { returnIframeUrl } from "../../../lib/http";
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import 'moment/locale/zh-cn';
import moment from 'moment';
moment.locale('zh-cn');

class ValuationChart extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			ListData: [], // 估值表
			listItems: [], // 项目列表
			showSpin: true,

			BoxType: '名称',	// 选框类型
			ProjectName: '', // 选框项目
			SelectNumber: '', // 选框编号
			valuation: '', // 选择日期

			Thevaluation: "", // 估值日期
			AssetValue: "", // 单位净值

			ItemNumber: "", // 下载项目编号
			valuationDate: "",//下载估值日期
		}
	};

	componentDidMount() {
		console.log(this.props, "props")

		const userInfo = window.config.sysConfig.userInfo;
		__waterDocumentSvg({
			container: document.getElementById('valuation_view'),
			// content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content: `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
			width: '700px',
			height: '550px',
			opacity: '0.1',
			fontSize: '26px',
			zIndex: 1000
		})

		this.getTableData(0)
		this.getProject()

		let { data } = this.props.data
		this.setState({ ProjectName: data.f5, valuation: data.f7, SelectNumber: data.f6 })
	}

	// 估值表
	getTableData = (a) => {
		let { ProjectName, valuation, BoxType, SelectNumber } = this.state
		let { data } = this.props.data
		let param = {}

		this.setState({showSpin:true})

		if (a) {
			if (BoxType == "名称") {
				param = {
					product_project_name: ProjectName,
					product_business_date: valuation
				}
			} else {
				param = {
					product_project_number: SelectNumber,
					product_business_date: valuation
				}
			}
		} else {
			param = {
				product_project_number: data.f6,
				product_business_date: data.f7
			}
		}
		APIService.getValuationRanking(param).then(res => {
			if (res.success) {
				this.setState({
					ListData: res.data,
					showSpin: false,
					Thevaluation: res.valuation_date,
					AssetValue: res.day_val,
					ItemNumber: res.product_project_number,
					valuationDate: res.valuation_date,
				})
			} else {
				message.error(res.error);
			}
		}).catch(err => {
			console.log('获取估值表数据排序接口 Error', err)
		})
	};
	// 项目下拉数据
	getProject = () => {
		APIService.getProjectList().then(res => {
			if (res.success) {
				this.setState({ listItems: res.rows })
			} else {
				message.error(res.error);
			}
		}).catch(err => {
			console.log('项目列表接口 Error', err)
		})
	}
	// 估值表查询下载接口
	exportExcel = () => {
		let { ItemNumber, valuationDate } = this.state

		let param = {
			product_project_number: ItemNumber,
			product_business_date: valuationDate,
		}

		let url = returnIframeUrl('/citic/get_download_Valuation_excel/', param);
		let aElement = document.createElement('a'); //创建节点
		document.body.appendChild(aElement);
		aElement.style.display = 'none';
		aElement.href = url;
		aElement.click();
		document.body.removeChild(aElement);
	};

	onChange = (date, dateString) => {
		console.log(date, dateString);
	}

	render() {
		let { ListData, showSpin, Thevaluation, AssetValue, listItems, ProjectName, valuation,
			BoxType, SelectNumber
		} = this.state

		let { data } = this.props.data

		const columns = [
			{
				title: '科目代码',
				dataIndex: 'subject',
				width: 220,
				ellipsis: true,
				aligin: 'center',
				className: 'maxk'
			},
			{
				title: '科目名称',
				dataIndex: 'course',
				width: 220,
				ellipsis: true,
				aligin: 'center',
			},
			{
				title: '数量',
				dataIndex: 'quantity',
				ellipsis: true,
				aligin: 'center',
			},
			{
				title: '单位成本',
				dataIndex: 'unit',
				ellipsis: true,
				width: 100,
				aligin: 'center',
			},
			{
				title: '成本',
				dataIndex: 'costing',
				width: 100,
				ellipsis: true,
				aligin: 'center',
			},
			{
				title: '成本占净值（%）',
				dataIndex: 'equity',
				ellipsis: true,
				aligin: 'center',
				width: 100,
			},
			{
				title: '市值',
				dataIndex: 'market',
				width: 100,
				ellipsis: true,
				aligin: 'center',
			},
			{
				title: '市值占净值（%）',
				dataIndex: 'MarketValue',
				width: 110,
				ellipsis: true,
				aligin: 'center',
			},
			{
				title: '估值增值',
				dataIndex: 'valuation',
				ellipsis: true,
				aligin: 'center',
				width: 120,
			},
			{
				title: '停牌信息',
				dataIndex: 'suspension',
				ellipsis: true,
				aligin: 'center',
				width: 120,
			},
			{
				title: '权益信息',
				dataIndex: 'information',
				ellipsis: true,
				aligin: 'center',
				width: 120,
			},
		];

		return (
			<ConfigProvider locale={zhCN}>

				<div id="valuation_view">
					<Spin spinning={showSpin} size="large">
						<div className="Valuation">
							<Row span={26} className="Valuation_title">
								<Col span={8}>
									<span className="monicker">项目</span>
									<Select
										disabled={data.NotOptional ? true : false}
										value={BoxType}
										style={{ width: "20%", marginLeft: 20 }}
										onChange={(value, option) => {
											console.log("value", value, option)
											this.setState({ BoxType: value })
										}}
									>
										{/* <Option value="名称">简称</Option> */}
										<Option value="名称">名称</Option>
										<Option value="编号">编号</Option>
									</Select>
									<Select
										showSearch
										disabled={data.NotOptional ? true : false}
										// style={{ width: "62%", height: 34 }}
										style={{ width: "60%" }}
										optionFilterProp="children"
										onChange={(value, option) => {
											console.log("value", value, option)
											if (BoxType == "名称") {
												this.setState({ ProjectName: option.children , SelectNumber:option.value })
											} else {
												this.setState({ SelectNumber: option.children , ProjectName:option.value })
											}
										}}
										value={BoxType == "名称" ? ProjectName : SelectNumber}
										filterOption={(input, option) =>
											option.children.indexOf(input.replace(/\s+/g, '')) >= 0
										}
									>
										{
											listItems.map((item, index) => {
												if (BoxType == "名称") {
													return <Select.Option key={index} value={item.project_id}>{item.name}</Select.Option>
												} else {
													return <Select.Option key={index} value={item.name}>{item.project_id}</Select.Option>
												}
											})
										}
									</Select>
								</Col>
								<Col span={4}>
									<span className="monicker">日期</span>
									<DatePicker
										getPopupContainer={triggerNode => triggerNode.parentNode}
										value={valuation !== "" ? moment(valuation, 'YYYY-MM-DD') : undefined}
										style={{ marginLeft: "10px", width: "65%", height: "32px" }}
										locale={locale} // 国际化 
										onChange={(value, time) => {
											console.log(time, "time")
											this.setState({ valuation: time })
										}}
									/>
								</Col>
								<Col className="operation" span={2.5}>
									<Space>

										<Button
											onClick={() => {
												this.getTableData(1)
											}}
										// size="small"
										// style={{ width: "72px", height: "25px", lineHeight: "25px", textAlign: "center" , color:"#D7000F" , border: "1px solid"}}
										>
											查 询
										</Button>
										<Button
											onClick={() => {
												this.exportExcel()
											}}
											// style={{ width: "72px", height: "25px", lineHeight:"25px", fontSize: '12px'}}
											style={{ color: 'white' }}
											type="primary"
										// size="small"
										>
											下载
										</Button>
									</Space>
								</Col>
								<Col span={4}>
									<p className="information">估值日期: {Thevaluation}</p>
								</Col>
								<Col span={4}>
									<p className="information">单位净值: {AssetValue}</p>
								</Col>
							</Row>
							<Row className="Valuation_Table">
								{
									/*
									<Table
										loading={showSpin}
										key={`${ListData}`}
										className="Valuation_Table"
										pagination={false} // 显示分页
										columns={columns}
										dataSource={ListData}
										size='small'
										bordered
										rowClassName={(record, index) => {
											let className = 'dark-row';
											if (index % 2 === 1) className = 'light-row';
											return className;
										}}
										scroll={{
											// y: 640,
											x:1600
										}}
									/>
									 */
								}

								<VueTable
									style={{ marginTop: "20px" }}
									data={ListData}
									key={ListData}
								/>
							</Row>
						</div>
					</Spin>
				</div>
			</ConfigProvider>
		)
	}
}
export default ValuationChart;


// WEBPACK FOOTER //
// app/components/customPage/Valuation/Valuation.jsx